module.exports = {
  EXPERIMENT_ENTITY_ID: 'ECEI',
  LAST_DISCARDED_NOTIFICATION: 'lastDiscardedNotification',
  LAST_READ_NOTIFICATION: 'lastReadNotificationTimestamp',
  MAIN: 'ECFG',
  HEIMDALL: 'ECHA',
  LOGIN_BETA: 'ECBT',
  INSTALL_DISMISSED: 'installMg-s',
  TYPETAG_LEGACY: '__tt',
  HEADER_INSTALL_CTA_DISMISSED: 'serpCtaDismiss',
  SEARCHES_AFTER_INSTALL: 'ECSAI',
  PRIVACY_CHOICE_TEST: 'EPCT',
  CONSENT: 'ECCC',
  WEB_CANARY: 'ECWC',
  ECOSIA_EXPERIMENT_DATA: 'ECED',
  REQUEST_ID: 'ECRQ'
};
